import {createApi} from "@reduxjs/toolkit/query/react"
import {IBasicResponse} from "../../types/api"
import baseQuery from "../../utils/apiIIKOConfig"
import {
    IPermissionListResponse,
    IUserByIdParams,
    IUserCreatePayload,
    IUserCreateResponse,
    IUserDetails,
    IUserListItem,
    IUserSelf,
    IUserUpdateBranchListPayload,
    IUserUpdatePasswordPayload,
    IUserUpdatePayload
} from "./UserApiTypes"


export const userApi = createApi({
    reducerPath: "userApi",
    baseQuery,
    tagTypes: ["users", "user-self", "permissions"],
    endpoints: (build) => ({
        getUsers: build.query<IBasicResponse<IUserListItem[]>, void>({
            query: () => ({
                url: "/v1/users",
                method: "GET",
            }),
            providesTags: ["users"]
        }),
        getUserById: build.query<IBasicResponse<IUserDetails>, IUserByIdParams>({
            query: ({id}) => ({
                url: `/v1/users/${id}`,
                method: "GET",
            }),
            providesTags: (_result, _error, arg) => [{type: "users", id: arg.id}]
        }),
        getSelfUser: build.query<IBasicResponse<IUserSelf>, void>({
            query: () => ({
                url: "/v1/users/self",
                method: "GET",
            }),
            providesTags: ["user-self"]
        }),
        getPermissionList: build.query<IBasicResponse<IPermissionListResponse>, void>({
            query: () => ({
                url: "/v1/permissions",
                method: "GET",
            }),
            providesTags: ["permissions"]
        }),
        createUser: build.mutation<IBasicResponse<IUserCreateResponse>, IUserCreatePayload>({
            query: (body) => ({
                url: "/v1/users",
                method: "POST",
                body
            }),
            invalidatesTags: ["users", "user-self"]
        }),
        updateUser: build.mutation<IBasicResponse<IUserDetails>, IUserUpdatePayload>({
            query: ({id, ...body}) => ({
                url: `/v1/users/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: (_result, _error, arg) => ["users", "user-self", {type: "users", id: arg.id}]
        }),
        updateUserPassword: build.mutation<IBasicResponse<void>, IUserUpdatePasswordPayload>({
            query: ({id, password}) => ({
                url: `/v1/users/${id}/passwords`,
                method: "PATCH",
                body: {password}
            })
        }),
        updateUserBranchList: build.mutation<IBasicResponse<void>, IUserUpdateBranchListPayload>({
            query: ({id, branch_id_list}) => ({
                url: `/v1/users/${id}/branches`,
                method: "PATCH",
                body: {branch_id_list}
            }),
            invalidatesTags: (_result, _error, arg) => ["users", "user-self", {type: "users", id: arg.id}]
        }),
        deleteUser: build.mutation<IBasicResponse<void>, IUserByIdParams>({
            query: ({id}) => ({
                url: `/v1/users/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: (_result, _error, arg) => ["users", "user-self", {type: "users", id: arg.id}]
        })
    })
})

export const {
    useGetUsersQuery,
    useGetUserByIdQuery,
    useGetSelfUserQuery,
    useGetPermissionListQuery,
    useCreateUserMutation,
    useUpdateUserMutation,
    useUpdateUserPasswordMutation,
    useUpdateUserBranchListMutation,
    useDeleteUserMutation
} = userApi
